import React from 'react';

const IconeBureu = ({ idBureau, taille, title }) => {
    switch(idBureau) {
        case 15 :
            let titres = title.split("/")
            let titre = titres.length > 1 ? "Demande personnelle / " + titres[1] : "Demande personnelle"
            return (<i className={`fas ${taille} fa-user-friends text-secondary`} title={titre}/>)
        case 121 :
            return (<i className={`fas ${taille} fa-exclamation-triangle text-secondary`} title={title}/>)
        case 122 :
            return (<i className={`fas ${taille} fa-calculator text-secondary`} title={title}/>)
        default : 
            return (<i className={`fas ${taille} fa-comments text-secondary`} title={title}/>)
    }
}  

export default IconeBureu;


// WEBPACK FOOTER //
// ./src/App_Data/IconeBureau.js